module.exports = __webpack_public_path__ + "img/world_map_back.a2c108d2.jpg";